import { AppSpecs } from '../experiments/appSpecs';

export function initWixRecorder(experiments: AppSpecs) {
  window.addEventListener('wixRecorderReady', async () => {
    try {
      await window.wixRecorder.addLabel('studio-templates');
      await window.wixRecorder.withExperiments(experiments);
    } catch (error) {
      console.error(error);
    }
  });
}
